<template>
  <div class="files">
    <div class="files__wrapper">
      <file-preview
        v-for="file in files"
        :key="file.id || file.url"
        class="file"
        :type="getFileType(file.url)"
        :url="file.url"
        :name="file.name"
        :actions="actions"
        :show-video="showVideo"
        :full-width="fullWidth"
        @click="showGallery(file)"
      />
    </div>

    <FsLightbox :toggler="lightbox" :sources="gallery" :slide="slide" :disable-local-storage="true" />
  </div>
</template>

<script>
import FsLightbox from "fslightbox-vue";
import FilePreview from "@/components/file-preview";

import { getFileType } from "@/utils/files";

export default {
  components: {
    FsLightbox,
    "file-preview": FilePreview,
  },
  props: ["files", "actions", "showVideo", "fullWidth"],

  data() {
    return {
      slide: 0,
      lightbox: false,
    };
  },

  computed: {
    gallery() {
      return this.files.map((file) => file.url);
    },
  },

  methods: {
    showGallery(file) {
      const index = this.files.indexOf(file);
      if (index === -1) return;
      this.slide = index + 1;
      this.lightbox = !this.lightbox;
    },

    getFileType(file) {
      return getFileType(file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.files {
  &__wrapper {
    margin-left: -6px;
    margin-right: -6px;
    margin-bottom: -15px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .file {
    margin-left: 6px;
    margin-right: 6px;
    margin-bottom: 15px;
  }
}
</style>
